<div class="center">
    <mat-dialog-content class="test-series-registration-form" style="scroll-behavior: unset;" (keyup)="keyEscape($event)">
        <div class="popup">
            <h1>One more step and you are all set</h1>
            <button type="button" class="close bg-close" data-dismiss="modal" aria-label="Close"
                (click)='closeDialogue()'><span aria-hidden="true" class="bg-close">&times;</span></button>

        </div>
        <div *ngIf="registrationErrorMessage" class="text-danger">
            {{registrationErrorMessage}}
        </div>
        <ng-container *ngIf="signupForm">
            <form [formGroup]="signupForm">
                <div class="signup-form-input-icons">
                    <div class="position-relative">
                        <img class="signup-form-input-icon" src="assets/img/phone-icon.svg" alt="" />
                        <input class="signup-form-input-field"  type="text" maxlength="10" formControlName="phone" placeholder="Phone Number">    
                    </div>
                    <!-- <button class="signup-form-input-button" (click)="editMobileNumber()">EDIT</button> -->
                    <mat-error class="error-msg" *ngIf="s.phone.touched && s.phone.errors?.required">
                        Mobile no is required
                    </mat-error>
                </div> 
    
                <div class="signup-form-input-icons">
                    <div class="position-relative">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/user.png" alt="" />
                        <input class="signup-form-input-field" type="text" formControlName="firstname" placeholder="First name" required>
                    </div>
                    <mat-error class="error-msg" *ngIf="s.firstname.touched && s.firstname.errors?.required">
                        First name is required
                    </mat-error>
                </div>
                <div class="signup-form-input-icons">
                    <div class="position-relative">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/user.png" alt="" />
                        <input class="signup-form-input-field" type="text" formControlName="lastname" placeholder="Last name" required>    
                    </div>
                    <mat-error class="error-msg" *ngIf="s.lastname.touched && s.lastname.errors?.required">
                        Last name is required
                    </mat-error>
                </div>
                <div class="signup-form-input-icons">
                    <div class="position-relative">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/mail.png" alt="" />
                        <input class="signup-form-input-field" type="text" formControlName="email" placeholder="Email" required>
                    </div>
                    <mat-error class="error-msg" *ngIf="s.email.errors?.pattern">
                        *Please enter valid email <address></address>
                    </mat-error>
                </div>
    
                <div class="signup-form-input-icons d-flex align-items-center" *ngIf="!hiddenFields.state" >
                    <strong class="flex-grow-0 flex-shrink-0 assessment_mr-10">State</strong>
                    <div class="select-gr">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/file-text.png" alt="" />
                        <select class='signup-form-input-field' placeholder='Grade' formControlName="state" required class="learn-pop">
                            <option value="" selected disabled>select</option>
                            <ng-container *ngIf="states?.length">
                                <option *ngFor="let state of states" [selected]='s?.state?.value == state.abbreviation' value="{{state.abbreviation}}">{{state.name}}</option>
                            </ng-container>
                        </select>
                    </div>
                </div>
                <div *ngIf="!hiddenFields.hallticket" class="signup-form-input-icons">
                    <div class="position-relative">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/digit.png" alt="" />
                        <input class="signup-form-input-field" type="text" formControlName="hallticket" placeholder="Neet Application Number">    
                    </div>
                </div>
    
                <div class="signup-form-input-icons">
                    <div class="position-relative">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/Frame.png" alt="" />
                        <input class="form-control signup-form-input-field" type="select" formControlName="source" [disabled]
                            placeholder="" required>
                    </div>
                    <mat-error class="error-msg" *ngIf="s.source.touched && s.source.errors?.required">
                        Source is required
                    </mat-error>
                </div>
                <div class="signup-form-input-icons d-flex align-items-center">
                    <strong class="flex-grow-0 flex-shrink-0 assessment_mr-10">Current Grade</strong>
                    <div class="select-gr">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/file-text.png" alt="" />
                        <select class='signup-form-input-field' placeholder='Grade' formControlName="grade" required class="learn-pop">
                            <!--option value="class 10">Class 10</option-->
                            <option value="" [selected]="s?.grade?.value == ''" disabled>select</option>
                            <ng-container *ngIf="grades?.length">
                                <option *ngFor="let gr of grades" [selected]="s?.grade?.value == gr.name" value="{{gr.name}}">{{gr.name}}</option>
                            </ng-container>
                        </select>
                    </div>
                </div>
    
                <div class="d-flex align-items-center" *ngIf="!hiddenFields.exam" >
                    <strong class="flex-grow-0 flex-shrink-0 assessment_mr-10">Select Exam</strong>
                    <div class="select-gr">
                        <img class="signup-form-input-icon" src="assets/img/neet-landing/file-text.png" alt="" />
                        <select class='signup-form-input-field' formControlName='exam' [value]="s?.exam?.value"
                            required class="learn-pop">
                            <!--option value="class 10">Class 10</option-->
                            <option value="" disabled>select</option>
                            <ng-container *ngIf="displayedExams?.length">
                                <option *ngFor="let exam of displayedExams" [value]="exam.name?.replaceAll(' ', '').toUpperCase()">{{exam.name}}</option>
                            </ng-container>
                        </select>
                    </div>
                </div>
                <div class="text-center">
                    <label class="UNFAPP-whtapp-chkarea">
                        <input type="checkbox" formControlName="whatsappConsent" (change)="checkbox()" checked>
                        <span class="_assessment_p-2 whtschkcnt"> Receive updates on Whatsapp</span>
                    </label>
                </div>
    
                <div class="terms-conditions assessment_mt-0">
                    By Signing up, you are agreeing to our <a class="anchor" (click)="openTermsAndConditionsDialog()">Terms
                        & Conditions and Privacy Policy</a>
                </div>
                <div class="text-center error-msg" *ngIf="formErrorExists">*All fields are mandatory</div>
                <button type="button" class="regandverify" data-toggle="mymodal" data-target="#exampleModalCenter2" (click)='next()'>REGISTER</button>
            </form>
        </ng-container>
    </mat-dialog-content>

</div>